// implemented Input Types in CustomFieldComponent
import {CustomFieldTO} from 'generated/JavaTO'

export enum InputType {
	Dq = 'Dq',
	String = 'String',
	Textarea = 'Textarea',
	Date = 'Date',
	Time = 'Time',
	JaNeinNull = 'JaNeinNull',
	JaNeinRadio = 'JaNeinRadio',
	JaNeinCheckbox = 'JaNeinCheckbox',
	File = 'File',
	Image = 'Image',
	Photo = 'Photo',
	Document = 'Document',
	DocumentOrImage = 'DocumentOrImage',
	Video = 'Video',
	Signature = 'Signature',
	GPS = 'GPS',
	Label = 'Label',
	Verbose = 'Verbose',
	Raw = 'Raw',
	DqRadio = 'DqRadio',
	Number= 'Number'
}

export const InputTypeDoc = {
	[InputType.Dq]: 'Dropdown Eingabefeld (Select)',
	[InputType.String]: 'Standard-Eingabefeld',
	[InputType.Textarea]: 'Standard-Eingabefeld, Zeilenvorschub (new line) erlaubt',
	[InputType.Time]: 'Standard-Eingabefeld',
	[InputType.Date]: 'Datepicker',
	[InputType.JaNeinNull]: 'Tri-State Select für z.B. persurl.offen_kz',
	[InputType.JaNeinRadio]: 'Radio Button Group die ein nachträgliches Löschen nicht mehr ermöglicht',
	[InputType.JaNeinCheckbox]: 'Checkbox für J/N Feld (benötigt default!)',
	[InputType.File]: "Datei mittels Drag & Drop hinzufügen. Benötigt type='B'",
	[InputType.Image]: "Bilder mittels Drag & Drop hinzufügen. Benötigt type='B'",
	[InputType.Photo]: "Bilder mittels Drag & Drop hinzufügen. Benötigt type='B'",
	[InputType.Document]: "Dokument mittels Drag & Drop hinzufügen. Benötigt type='B'",
	[InputType.DocumentOrImage]: "Dokument oder Bild mittels Drag & Drop hinzufügen. Benötigt type='B'",
	[InputType.Video]: "Video mittels Drag & Drop hinzufügen. Benötigt type='B'",
	[InputType.Signature]: "Unterschrift erfassen. Benötigt type='B'",
	[InputType.GPS]: 'GPS Input. Generiert Daten in cf_gps: lat,lon!',
	[InputType.Label]: 'Nur Label wird angezeigt',
	[InputType.Verbose]: '(noch nicht implementiert in react)',
	[InputType.Raw]: '(noch nicht implementiert in react)',
	[InputType.DqRadio]: 'Datenquelleninhalt wird durch Radio-Buttons dargestellt',
	[InputType.Number]: "Dezimalzahlen unter berücksichtiung Komma oder Punkt und Rundung"
} as const

export const isCFInputTypeInline = (cfDef?: CustomFieldTO) => cfDef && cfDef.input === InputType.JaNeinCheckbox && cfDef.maxAmount === 1;